import React, { Component } from "react";
import Tuna from "tunajs";
import styled from "styled-components";
import set from "lodash.set";
import slugify from "slugify";

import tunaSettings from "./tunaSettings";
import encode from './encode';

//import VorbisEncoder from "libvorbis.js";

/*
function encodeAudioBuffer(audioBuffer, cb) {

  var encoder = new VorbisEncoder();

  console.log(encoder);

  var chunks = [];

  encoder.ondata = (data) => {
      chunks.push(data);
  };

  encoder.onfinish = () => {
      console.timeEnd('encode');

      var blob = new Blob(chunks, { type: 'audio/ogg' });
      chunks = [];
      var url = URL.createObjectURL(blob);
      cb(url);
  };

  function encode(audioBuffer) {
      var buffers = [];

      var samples = audioBuffer.length;

      var channels = audioBuffer.numberOfChannels;

      for (var ch = 0; ch < channels; ++ch) {
          // make a copy
          const array = audioBuffer.getChannelData(ch).slice();

          buffers.push(array.buffer);
      }

      encoder.encode(buffers, samples, channels);
  }

  var samples = audioBuffer.length;

  var channels = audioBuffer.numberOfChannels;

  var sampleRate = audioBuffer.sampleRate;

  var chunkSize = 10 * 4096;

  console.time('encode');

  encoder.init(channels, sampleRate, 0.5);

  var ctx = new AudioContext();

  for (var n = 0; n < samples; n += chunkSize) {
      var actualSize = Math.min(chunkSize, samples - n - 1);

      var chunkBuffer = ctx.createBuffer(channels, actualSize, ctx.sampleRate);

      for (var ch = 0; ch < channels; ch += 1) {
          var src  = audioBuffer.getChannelData(ch).subarray(n, n + actualSize);
          var dest = chunkBuffer.getChannelData(ch);
          dest.set(src);
      }

      encode(chunkBuffer);
  }

  encoder.finish();
}
*/

const convertToDataUrl = (arrayBuffer, mimetype) => new Promise((resolve, reject) => {
  const blob = new Blob([arrayBuffer], { type: mimetype });
  const fileReader = new FileReader();
  fileReader.onload = event => resolve(fileReader.result);
  fileReader.readAsDataURL(blob);
});


const Text = styled.textarea`
  padding: 10px;
  width: 400px;
  height: 120px;
  font-size:16px;
`;

const TTS_API_URL = "https://testtts.now.sh/tts";

const getTranslateApiUrl = (language = "fr", text) =>
  `${TTS_API_URL}/download/${language}/${encodeURIComponent(text)}`;

const Container = styled.div`
  text-align: center;
`;


class App extends Component {
  state = {
    text: "Mon nom est Alice. Introduisez vos questions par mon prénom.",
    language: "fr",
    rate: 1,
    playing: false,
    output: null,
    tunaSettings: tunaSettings
  };
  onChangeHandler = e => {
    e.persist();
    this.setState(prevState => set(prevState, e.target.name, e.target.value));
  };
  componentWillMount() {
    this.audioBuffer = null;
    this.audioContext = new AudioContext();
    this.bufferSourceNode = undefined;
  }

  componentDidMount() {
    this.getTTS();
  }

  applyTuna = (context, buffer) => {
    var output = context.createGain();
    buffer.connect(output);

    const tuna = new Tuna(context);
    Object.keys(this.state.tunaSettings)
      .filter(effectName => this.state.tunaSettings[effectName].enabled)
      .forEach(effectName => {
        console.log("applyTuna", effectName);
        const effect = new tuna[effectName](
          this.state.tunaSettings[effectName]
        );
        buffer.connect(effect.input);
        effect.connect(output);
      });

    return output;
  };

  applyAudioEffects() {
    if (!this.audioBuffer) {
      return;
    }
    const currentTime = this.audioContext.currentTime;
    if (this.bufferSourceNode) {
      this.bufferSourceNode.disconnect();
    }
    this.bufferSourceNode = this.audioContext.createBufferSource();
    this.bufferSourceNode.buffer = this.audioBuffer;
    //this.bufferSourceNode.loop = true;
    this.bufferSourceNode.playbackRate.value = this.state.rate;
    this.bufferSourceNode.onended = e => {
      console.log("bufferSourceNode.ended")
      this.setState({
        playing: false
      })
    }
    const output = this.applyTuna(this.audioContext, this.bufferSourceNode);

    output.connect(this.audioContext.destination);

    this.bufferSourceNode.start(currentTime);
  }
  // listen = () => {
  //   if (this.bufferSourceNode === undefined) {
  //     this.applyAudioEffects();
  //   } else {
  //     this.bufferSourceNode.disconnect();
  //     this.bufferSourceNode = undefined;
  //   }
  // };
  togglePlay = () => {
    if (this.state.playing) {
      this.stop();
    } else {
      this.play();
    }
  }
  stop = () => {
    this.setState({
      playing: false
    }, () => {
      this.bufferSourceNode.disconnect();
      this.bufferSourceNode = undefined;
    })
  }
  play = () => {
    this.setState({
      playing: true
    }, () => {
      this.applyAudioEffects();
    })
  };
  getTTS = () => {
    const url = getTranslateApiUrl(this.state.language, this.state.text);
    fetch(url)
      .then(response => response.arrayBuffer())
      .then(arrayBuffer => this.audioContext.decodeAudioData(arrayBuffer))
      .then(dBffr => this.audioBuffer = dBffr)
      .then(() => this.forceUpdate())
      .then(() => this.play())
      .catch(err => console.warn(err));
  };
  download = () => {
    if (this.audioBuffer === undefined) {
      return;
    }

    // add 1 second at the end
    const length = this.audioBuffer.length / this.state.rate +
      this.audioBuffer.sampleRate * 1;
    const offlineAudioContext = new OfflineAudioContext(
      this.audioBuffer.numberOfChannels,
      length,
      this.audioBuffer.sampleRate
    );

    // Create a AudioBufferSourceNode with the decoded audioBuffer.
    const bufferSourceNode = offlineAudioContext.createBufferSource();

    bufferSourceNode.buffer = this.audioBuffer;
    bufferSourceNode.playbackRate.value = this.state.rate;
    bufferSourceNode.start(0);

    const output = this.applyTuna(offlineAudioContext, bufferSourceNode);
    output.connect(offlineAudioContext.destination);

    const getFileName = sentence => slugify(sentence.toLowerCase().replace(/\./g,'-'))

    return offlineAudioContext
      .startRendering()
      .then(audioBuffer => {
        const typedArrays = [];

        for (let i = 0; i < audioBuffer.numberOfChannels; i += 1) {
          const typedArray = new Float32Array(audioBuffer.length);

          audioBuffer.copyFromChannel(typedArray, i);
          typedArrays.push(typedArray);
        }
        // return encodeAudioBuffer(typedArrays, data => {
        //   console.log('FINISH encodeAudioBuffer', data)
        // })
        return encode(typedArrays);
      })
      .then(arrayBuffer => convertToDataUrl(arrayBuffer, "audio/wav"))
      .then(dataUrl => {
        //window.open(dataUrl);
        var a = document.createElement("a");
        a.download = `${getFileName(this.state.text)}.ogg`;
        a.href = dataUrl;
        a.click();
        if (a.remove) a.remove();
        // this.setState({
        //   output: dataUrl
        // });
      })
      .catch(err => console.warn(err));
  };

  render() {
    if (this.state.playing) {
      this.applyAudioEffects();
    }
    console.log("render", this.state);
    return (
      <Container>
        <Text
          name="text"
          value={this.state.text}
          onChange={this.onChangeHandler}
        />
        <br /><br />
        <select
          value={this.state.language}
          onChange={e => this.setState({ language: e.target.value })}
        >
          <option>fr</option>
          <option>en</option>
        </select>
        <button onClick={this.getTTS}>Text-to-speech</button>
        <button onClick={this.togglePlay}>
          { this.state.playing ? '▉' : '▶' }
        </button>
        <br /><br />
        Speed
        <input
          name="rate"
          type="range"
          min="0.5"
          max="1.5"
          step="0.05"
          value={this.state.rate}
          onChange={this.onChangeHandler}
        />
        {this.state.rate}
        <br /><br />
        <button disabled={!this.audioBuffer} onClick={this.download}>
          Download .wav
        </button>
        {this.state.output}
      </Container>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js